// extracted by mini-css-extract-plugin
export var box = "_7b-1";
export var checked = "_7b-2";
export var descriptionSpacer = "_7b-9";
export var disabled = "_7b-3";
export var icon = "_7b-6";
export var input = "_7b-0";
export var labelSpacer = "_7b-8";
export var medium = "_7b-5";
export var small = "_7b-4";
export var text = "_7b-7";